module.exports = __webpack_public_path__ + "img/finding-workforce.63e833d0.svg";